export const GET_ORDER_REQUESTED  = 'GET_ORDER_REQUESTED';
export const GET_ORDER_SUCCESS    = 'GET_ORDER_SUCCESS';
export const GET_ORDER_FAILED     = 'GET_ORDER_FAILED';
